import { persistReducer } from 'redux-persist';

import { CHANGE_LANGUAGE } from '../constants/language';

const initialState = {
  current: 'en'
}

function language(state = initialState, action) {
  const { type, payload } = action;

  switch(type) {
    case CHANGE_LANGUAGE:
      return { ...state,
        current: payload
      };
    
      default:
        return state;
  }
}

export default (storages) => {
  const languagePersistConfig = {
    key: 'language',
    storage: storages,
    whitelist: ['current']
  };

  return persistReducer(languagePersistConfig, language);
};


// WEBPACK FOOTER //
// ./src/reducers/language.js